import { fetchToken } from "../components/sharedComponents/auth-wrapper";
import { ApiDownloader } from "./ApiDownloader";

export const ApiDownloadCaller = () => {
  const callApiSkipErrorHandling = async (type, route, params) => {
    let token = await fetchToken();
    return ApiDownloader(type, token, route, params).then((res) => {
      if (res.status === 200 || res.status === 201) return res.data;
    });
  };

  return { callApiSkipErrorHandling };
};
